export default {
    'INTL': /^(.{1,255})$/,   
}